__turbopack_context__.v({
  "shimmerLabel": "ChatGeneratingIndicator-module-scss-module__NWuVlG__shimmerLabel",
  "welloAgentLabelShimmer": "ChatGeneratingIndicator-module-scss-module__NWuVlG__welloAgentLabelShimmer",
});
